import { render } from "./ChooseColors.vue?vue&type=template&id=561a0f24&scoped=true&ts=true"
import script from "./ChooseColors.vue?vue&type=script&lang=ts"
export * from "./ChooseColors.vue?vue&type=script&lang=ts"

import "./ChooseColors.vue?vue&type=style&index=0&id=561a0f24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561a0f24"],['__file',"src/components/start/ChooseColors.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "561a0f24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('561a0f24', __exports__)) {
    api.reload('561a0f24', __exports__)
  }
  
  module.hot.accept("./ChooseColors.vue?vue&type=template&id=561a0f24&scoped=true&ts=true", () => {
    api.rerender('561a0f24', render)
  })

}


export default __exports__